import { Button, Stack, Typography } from '@mui/material'

import { Maybe, PersonalInfoFragment } from '@/clients/utoniq-core/schema'
import { styleSets } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type UserAccountCellProps = {
  user?: Maybe<PersonalInfoFragment>
}

export const UserAccountCell: Cell<UserAccountCellProps> = ({ user }) => {
  const { t } = useTranslation('personalInfoSettings')
  const { routerPages } = useRouter()
  return (
    <CellFrame sx={{ py: 6 }}>
      <Stack spacing={2}>
        <Typography variant="subtitle1" color="text.secondary">
          {t('emailAddress', 'メールアドレス')}
        </Typography>
        <Stack direction="row" alignItems="center" spacing={4}>
          <Stack flex={1} minWidth={0}>
            <Typography variant="body1" sx={styleSets.lineCamp(1)}>
              {user?.email}
            </Typography>
          </Stack>
          <Button
            variant="outlined"
            size="small"
            href={routerPages.EmailSetting}
            sx={{ color: 'primary.main', borderColor: 'primary.main' }}
          >
            {t('change', '変更する')}
          </Button>
        </Stack>
      </Stack>
      <Stack pt={4} spacing={2}>
        <Typography variant="subtitle1" color="text.secondary">
          {t('password', 'パスワード')}
        </Typography>
        <Stack direction="row" alignItems="center" spacing={4}>
          <Stack flex={1} minWidth={0}>
            <Typography variant="body1" sx={styleSets.lineCamp(1)}>
              ***************
            </Typography>
          </Stack>
          <Button
            variant="outlined"
            size="small"
            href={routerPages.PasswordSetting}
            sx={{ color: 'primary.main', borderColor: 'primary.main' }}
          >
            {t('change', '変更する')}
          </Button>
        </Stack>
      </Stack>
    </CellFrame>
  )
}
